<template>
  <div class="g">
    <!-- 头部导航栏 -->
    <div class="litops orangeToYellow com_top">
      <!-- 设备名称 -->
      <span class="refresh" @click="handleRefresh">
        <span class="iconfont icon-shuaxin1" />
        <span class="txt">刷新数据</span>
      </span>
      <!-- 设备编号 -->
      <span class="tit">轮灌程序</span>
    </div>

    <!-- 顶部按钮组 -->
    <div class="g_ctn">
      <div class="g_opt">
        <div class="get" @click="handleControl(programStatus != 1 ? 'run' : 'pause')">
          <div class="circular">
            <span class="iconfont icon-yunduanshuaxin" />
          </div>
          <span v-if="!programStatus || programStatus == 2" class="text">
            启动程序
            <div v-if="programStatus == 2" :style="{ color: 'red', fontSize: '12px', textAlign: 'center' }">(暂停中)</div>
          </span>
          <span v-else class="text">暂停程序</span>
        </div>
        <div class="get" @click="handleControl('end')">
          <div class="circular">
            <span class="iconfont icon-shezhi" />
          </div>
          <span class="text">停止程序</span>
        </div>
      </div>
    </div>

    <!-- 时间规划 -->
    <div class="show_time" v-if="!hasFertilizationMeasurement">
      <div class="item" v-for="item in showTime" :key="item.label">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>
    <div class="show_time" v-else>
      <div class="item" v-for="item in showMeasurement" :key="item.label">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>

    <!-- 设备分组 -->
    <div class="group">
      <div class="item card" v-for="(item, index) in pumpGroups" :key="`${index}_pumpGroups`">
        <div class="row1">
          <div class="r_t">
            <span class="cir">
              <span class="iconfont icon-shuibeng"></span>
            </span>
            <span class="name">{{ item.groupName }}</span>
          </div>
          <div class="r_b">
            <van-field type="number" v-for="(valve, index) in item.valveList" :key="index" :value="valve" disabled
              :class="['inp', item && item.status && 'valve_active']" />
          </div>
        </div>
        <div class="row2"></div>
      </div>
    </div>

    <!-- RTU阀门分组 -->
    <div class="group valveGroups">
      <div :class="['item', index <= currentGroup && status && 'active']" v-for="(item, index) in valveGroups"
        :key="index">
        <!-- 进度条 -->
        <div class="left">
          <div class="cir">
            <div class="cir2"></div>
          </div>
          <div class="line" v-if="index + 1 !== valveGroups.length"></div>
        </div>
        <!-- 阀门 -->
        <div class="right">
          <div class="row row1">
            <div class="font">
              <i class="iconfont icon-shenghuoshuibengfang" />
            </div>
            <div>{{ item.groupName }}</div>
            <div class="txt">执行：{{ currentGroup == index ? item.irrigationTime : 0 }} 分钟</div>
            <div class="txt">时长：{{ item.min }}分钟</div>
          </div>
          <div class="row row2"></div>
          <div class="row row3" v-if="item.valve_group && item.valve_group.length">
            <!-- checkRTUValveActive(_item, index) -->
            <div :class="['item_valve', status && index <= currentGroup && 'valve_active']"
              v-for="(_item, _index) in item.valve_group" :key="`${_index}_${_item}`">
              {{ _item }}
            </div>
          </div>
          <!-- 施肥机 -->
          <div class="row row5">
            <div class="rwo top">
              <span class="icon"><i class="iconfont icon-shifei" /></span>
              <span class="tit">{{ item.requireManure ? '需要施肥' : '不需要施肥' }}</span>
              <span :class="['need']">{{ shifeiRunTimeStatus(item.status) }}</span>
            </div>
            <div class="rwo bottom" v-if="item.requireManure">
              <div class="time time1">
                <span>预充：</span>
                <span>{{ item.havPreTime }}/{{ item.preTime }}</span>
                <span>分钟</span>
              </div>
              <div class="time time2">
                <span>施肥：</span>
                <span>{{ item.havManureTime }}/{{ item.manureTime }}</span>
                <span>分钟</span>
              </div>
              <div class="time time3">
                <span>冲洗：</span>
                <span>{{ item.havWashTime }}/{{ item.washTime }}</span>
                <span>分钟</span>
              </div>
            </div>

          </div>
          <div class="progress">
            <van-progress :percentage="item.process" stroke-width="6" :show-pivot="false" />
            <div class="progress-text">{{ item.loadMin }}&nbsp;/&nbsp;{{ item.totalMin }} &nbsp;&nbsp;分钟（组总时长）</div>
          </div>
          <div class="row row4">
            <div class="font">
              <div class="yuan">
                <i class="iconfont icon-qiehuan"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      no: "",
      hasFertilizationMeasurement: false,
      showMeasurement: [
        {
          key: "startTime",
          label: "开始时间",
          value: "",
        },
        {
          key: "totalDuration",
          label: "总的施肥量",
          value: "",
        },
        {
          key: "surplusTime",
          label: "已施肥量",
          value: "",
        },
        {
          key: "endTime",
          label: "剩余施肥",
          value: "",
        },
      ],

      showTime: [
        {
          key: "totalDuration",
          label: "共计用时",
          value: "",
        },
        {
          key: "startTime",
          label: "开始时间",
          value: "",
        },
        {
          key: "surplusTime",
          label: "剩余时间",
          value: "",
        },
        {
          key: "endTime",
          label: "完成时间",
          value: "",
        },
      ],
      pumpGroups: [],
      valveGroups: [],
      status: null,
      pumpGroupsStatus: [],
      valveGroupsStaus: [],
      currentGroup: null,
      program: null,
      type: null,
      programStatus: null, // 是否启动了
    };
  },
  computed: {
    shifeiRunTimeStatus () {
      return function (num) {
        // 01：正在灌溉 02：正在预充 03：正在施肥 04 正在冲洗
        if (num == 1) return '正在灌溉'
        else if (num == 2) return '正在预充'
        else if (num == 3) return '正在施肥'
        else if (num == 4) return '正在冲洗'
        else if (num == 5) return '已灌溉'
        else return '未灌溉'
      }
    },
  },
  async mounted () {
    const no = localStorage.getItem("no");
    this.type = sessionStorage.getItem("deviceType")
    this.no = no;

    // 解析路由参数
    const { data } = this.$route.query
    let query = {}
    if (data) {
      query = JSON.parse(data)
    }
    this.program = { ...query }
    await this.handleRefresh();
  },

  methods: {
    async handleRefresh () {
      try {
        this.$toast.loading({
          message: "数据加载中...",
          forbidClick: true,
          duration: 0
        })

        // 读取分组
        await this.getStatus()

        setTimeout(() => {
          let elm = this.$el.querySelectorAll(".active");
          if (elm && elm.length) {
            const eleDom = [...elm]
            eleDom.map((item, index) => {
              const target = item.getElementsByClassName("line");
              if (index === eleDom.length - 1) {
                target[target.length - 1].style.cssText =
                  "background: linear-gradient(to bottom,rgba(58, 106, 224, 1),rgba(53, 105, 233, 0.2)) !important";
              } else {
                target[target.length - 1].style.cssText = "background: rgba(58, 106, 224, 1) !important";
              }
            })
          }
        }, 400)


        this.$toast.clear()
      } catch (e) {
        this.$toast.clear()
      }
    },

    // 程序控制
    async handleControl (type) {
      this.$toast.loading({
        message: "操作执行中...",
        forbidClick: true,
        duration: 0
      })

      // 请求所有组的执行状态 如果自身程序已启动 则返回已在运行中
      // 如果其他程序在启动 则返回 有其他程序启动中
      if (type === "run" || type === "pause") {
        const _res = await this.$api.lgV3_getProgram_list(this.no)
        if (_res.errcode === 0) {
          const data = _res.data
          const find = data.find(o => o.sta == 1)
          const find2 = data.find(o => o.sta == 2)
          // const find3 = data.find(o => o.index == this.program.index)

          if (find && find.index != this.program.index) {
            return this.$toast({
              message: `${find.index + 1}号程序在执行中，无法继续${type === "run" ? '开启' : '暂停'}`,
              duration: 2000
            })
          }
          if (find2 && find2.index != this.program.index) {
            return this.$toast({
              message: `${find2.index + 1}号程序已暂停，无法继续${type === "run" ? '开启' : '暂停'}`,
              duration: 2000
            })
          }
        }
      }

      // no cmd[【命令=run-运行，pause-暂停，end-结束]
      await this.$api.lgV2_control(this.no, type, this.program.index).then(res => {
        this.$toast({
          message: res.errcode === 0 ? (type === "run" ? "启动成功" : type === "pause" ? '暂停成功' : "关闭成功") : res.errmsg,
          duration: 2000
        })
      });
    },

    // 查询全部阀门的状态
    async getAllValveStatus () {
      await this.$api.lgV2_getAllValveStatus(this.no).then((res) => {
        if (res.errcode === 0) {
          const { pumpGroups, valveGroups } = res.data
          this.pumpGroupsStatus = pumpGroups
          this.valveGroupsStaus = valveGroups
        } else {
          this.$toast("查询程序状态:" + res.errmsg);
        }
      });
    },

    // 获取程序状态
    async getStatus () {
      try {
        await this.$api.lgV3_getProgramStatus({
          gatewayNo: this.no,
          proId: this.program.index
        }).then((res) => {
          if (res.errcode === 0) {
            const {
              totalTime, // 共计用时
              startTime,  // 开始时间
              surplusTime, // 剩余时间
              endTime, // 结束时间
              status, // 运行状态 状态 01，开启 02，暂停 03，停止
              groupIndex, // 当前执行到第几组
              manureStatusList, // 组施肥状态
              valveGroupList, // 组阀门编号
              pumpList,// 水泵号位
              manureList, // 施肥机号位
              pumpStatus, // 水泵状态 0关闭，1开启
              manureStatus, // 施肥机状态 0关闭，1开启
            } = res.data;
            this.status = status == 1;
            this.programStatus = status

            const obj = {
              surplusTime: typeof surplusTime === "number" ? this.getTime(surplusTime) : surplusTime,
              totalDuration: typeof totalTime === "number" ? this.getTime(totalTime) : totalTime,
              endTime: typeof endTime === "number" ? this.getTime(endTime) : endTime,
              startTime: typeof startTime === "number" ? this.getTime(startTime) : startTime,
            };




            // 水泵 施肥机的号位展示
            // 水泵只要程序状态开启就是直接开启
            pumpList && this.pumpGroups.push({ groupName: "水泵", valveList: pumpList, status: Boolean(pumpStatus) })
            //
            manureList && this.pumpGroups.push({ groupName: "施肥机", valveList: manureList, status: Boolean(manureStatus) })

            // 分组 manureStatusList
            const valveGroups = []
            let hasFertilizationMeasurement = false // 是否有计量施肥
            let totalFertilizationAmount = 0 // 总的施肥量

            valveGroupList.map((o, i) => {
              const obj = {}
              if (!obj.groupName) { obj.groupName = `第${i + 1}组`; }
              const groupStatus = manureStatusList[i]
              const {
                status,
                setTime,
                preTime,
                manureTime,
                washTime,
                havPreTime,
                havManureTime,
                havWashTime,
                irrigationTime,
                requireManure,

              } = groupStatus

              // 状态 01，开启 02，暂停 03，停止
              obj.check = status == 2;
              // 总的需要执行的时长
              const t = setTime ? setTime / 60 : 0;
              obj.min = String(t).indexOf(".") > -1 ? t.toFixed(2) : t;
              // 施肥机三个时间的总时间
              obj.preTime = ((preTime || 0) / 60)
              obj.manureTime = ((manureTime || 0) / 60)
              obj.washTime = ((washTime || 0) / 60)
              // 施肥机三个时间的已经灌溉的时间
              obj.havPreTime = this.cocaluta60Time(havPreTime)
              obj.havManureTime = this.cocaluta60Time(havManureTime)
              obj.havWashTime = this.cocaluta60Time(havWashTime)

              obj.irrigationTime = this.cocaluta60Time(irrigationTime)
              obj.requireManure = requireManure == 1
              obj.valve_group = o
              obj.process = ((irrigationTime / setTime).toFixed(1)) * 100

              obj.loadMin = this.cocaluta60Time(irrigationTime)
              obj.totalMin = this.cocaluta60Time(setTime)
              obj.status = status
              valveGroups.push(obj)


              if (o.requireManure == 2) {
                hasFertilizationMeasurement = true
                totalFertilizationAmount += (o.manureTime / 10)
              }
            });

            // 有计量施肥 展示施肥量的统计数据
            console.log("hasFertilizationMeasurement:", hasFertilizationMeasurement);

            this.hasFertilizationMeasurement = hasFertilizationMeasurement
            if (hasFertilizationMeasurement) {
              this.showMeasurement[1].value = totalFertilizationAmount
            } else {
              // 时间展示
              this.showTime.map((o) => {
                o.value = obj[o.key];
              });
            }

            this.valveGroups = [...valveGroups];
            this.currentGroup = groupIndex



            this.pumpGroups = []

            console.log(" this.valveGroups:", this.valveGroups);

          } else {
            this.$toast("查询程序状态:" + res.errmsg);
          }
        })

      } catch (e) {
        console.error("e:", e);
      }
    },

    cocaluta60Time (time) {
      const t = String((time || 0) / 60)
      if (t.indexOf(".") > -1) {
        return Number(t).toFixed(2)
      }

      return t
    },

    // RTU 阀门 去阀门状态中查找这个阀门是否开始 来渲染颜色
    checkRTUValveActive (valName, index) {
      if (!this.valveGroupsStaus || !this.valveGroupsStaus.length) return false
      const target = this.valveGroupsStaus.find(o => o.index === valName)
      if (target && target.status) return true
      return false
    },

    getTime (second) {
      second = Number(second);
      let h = 0,
        m = 0,
        s = 0;

      const u_h = 60 * 60;
      const u_m = 60;

      h = Math.floor(second / u_h);
      m = Math.floor((second - h * u_h) / u_m);
      s = second - h * u_h - m * u_m;

      const M = String(m).padStart(2, "0");
      const S = String(s).padStart(2, "0");
      if (h) {
        const H = String(h).padStart(2, "0");
        return `${H}:${M}:${S}`;
      }

      return `${M}:${S}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.g {
  background: rgba(241, 247, 255, 1) !important;
}

.com_top {
  font-size: 16px;
  color: #fff;
  padding: 20px 0;
  line-height: 100%;
  text-align: center;

  .refresh {
    position: absolute;
    left: 10px;

    .txt {
      margin-left: 6px;
    }

    .icon-shuaxin1 {
      font-size: 16px;
    }
  }

  .tit {
    font-size: 20px;
  }
}

.g_ctn {
  margin-bottom: 10px;

  .g_opt {
    display: flex;
    align-items: center;
    height: 55px;
    padding: 18px 28px;
    background: #ffffff;
  }

  .get {
    display: flex;
    flex: 1;
    align-items: center;

    &:first-child {
      border-right: 0.5px solid rgba(232, 232, 232, 1);
    }

    &:last-child {
      justify-content: center;
    }

    .text {
      font-size: 16px;
      margin-left: 11px;
    }

    .circular {
      width: 39px;
      height: 39px;
      background: linear-gradient(90deg,
          rgba(72, 119, 233, 1) 0%,
          rgba(25, 76, 201, 1) 100%);

      border-radius: 50%;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .icon-yunduanshuaxin,
    .icon-shezhi {
      font-size: 24px !important;
    }
  }
}

.show_time {
  display: flex;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 4px rgba(30, 152, 246, 0.05);
  border-radius: 8px;
  font-size: 16px;
  margin: 10px;

  .item {
    flex: 1;
    text-align: center;
    border-right: 0.5px solid rgba(232, 232, 232, 1);

    &:last-child {
      border: none;
    }

    .label {
      color: rgba(51, 51, 51, 1);
      padding: 8px;
      border-bottom: 0.5px solid rgba(232, 232, 232, 1);
    }

    .value {
      color: rgba(136, 136, 136, 1);
      padding: 9px 0;
      font-size: 14px;
    }
  }
}

.card {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 10px 7px;
  margin-bottom: 12px;
  margin: 0 10px;

  .row1 {
    font-size: 14px;

    .r_t {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
    }

    .txt {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 8px;
      padding-right: 10px;
    }

    .r_b {
      display: flex;

      .r_b_l {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
      }

      .inp {
        width: 48px;
        height: 35px;
        border: 0.5px solid rgba(151, 151, 151, 1);
        border-radius: 4px;
        margin-right: 7px;
        // margin: 5px;
        padding: 8px !important;

        ::v-deep input {
          text-align: center !important;
        }
      }

      .cir {
        width: 26px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 24px;
        color: #ffffff;
        border-radius: 50%;
      }

      .reduce {
        background: rgba(214, 218, 221, 1);
        box-shadow: 0px 2px 2px rgba(229, 229, 229, 1);
      }

      .add {
        background: rgba(53, 102, 220, 1);
        box-shadow: 0px 2px 2px rgba(49, 171, 254, 0.2);
      }

      .value {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        margin: 0 9px;
      }

      .btn {
        display: flex;
        align-items: center;
      }
    }

    .icon-shuibeng {
      font-size: 25px;
    }

    .cir {
      display: block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50%;
      background: rgba(59, 107, 224, 1);
      color: #ffffff;
      text-align: center;
    }

    .name {
      margin-left: 13px;
      font-size: 16px;
    }
  }
}

.valveGroups {
  background: #ffffff;
  margin: 10px;
  padding: 9px 11px;
  font-size: 16px;
  border-radius: 8px;

  .item {
    display: flex;

    .left {
      margin-right: 10px;
      padding-top: 23px;

      .cir {
        width: 18px;
        height: 18px;
        text-align: center;
        line-height: 18px;
        border-radius: 50%;
        padding: 6px 0 0 6px;
        background: rgba(216, 216, 216, 1);
      }

      .cir2 {
        width: 12px;
        height: 12px;
        background: #ffffff;
        border-radius: 50%;
      }

      .line {
        width: 5px;
        height: 100%;
        margin-left: 9px;
        background: rgba(216, 216, 216, 1);
      }
    }

    .right {
      flex: 1;
    }

    .row {
      display: flex;
      align-items: center;
      width: 100%;
    }

    .row1 {
      justify-content: space-between;
      padding-bottom: 11px;
      border-bottom: 0.5px solid rgba(232, 232, 232, 1);

      .font {
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 50%;

        background: rgba(40, 89, 211, 1);

        i {
          color: #ffffff;
        }
      }

      .txt {
        color: rgba(151, 151, 151, 1);
        font-size: 14px;
      }
    }

    .row3 {
      display: flex;
      flex-wrap: wrap;
      margin: 20px 0 0;

      .item_valve {
        width: 42px;
        height: 31px;
        line-height: 31px;
        text-align: center;
        border: 0.5px solid rgba(151, 151, 151, 1);
        border-radius: 4px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }

    .row4 {
      position: relative;
      width: calc(100% - 42px);
      height: 1px;
      border-bottom: 1px dashed rgba(216, 216, 216, 1);
      margin-bottom: 30px;
      margin-top: 25px;

      .font {
        position: absolute;
        top: -21px;
        right: -42px;
        width: 42px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: rgba(216, 216, 216, 0.2);
        border-radius: 50%;

        .yuan {
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: rgba(216, 216, 216, 1);
          border-radius: 50%;
          margin: 6px 0 0 6px;

          i {
            color: #ffffff;
          }
        }
      }
    }

    .row5 {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      background: #f5f7fb;
      border-radius: 6px;
      padding: 10px;
      box-sizing: border-box;
      padding: 14px 14px;

      .icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 50%;
        text-align: center;
        background: #3b6be0;

        i {
          color: #ffffff;
          font-size: 12px;
        }
      }

      .tit {
        margin-left: 4px;
      }

      .bottom {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        margin-top: 14px;

        .time {
          width: 50%;
          margin-bottom: 10px;
        }
      }

      .need {
        display: inline-block;
        vertical-align: center;
        width: 70px;
        padding: 3px 00px;
        background: rgba(27, 224, 141, 0.15);
        border-radius: 20px;
        color: #29bc7e;
        font-size: 14px;
        margin-left: 14px;
        text-align: center;
      }

      .noneed {
        background: #d8d8d8;
        color: #ffffff;
      }
    }
  }

  .active {
    .cir {
      background: rgba(58, 106, 224, 1) !important;
    }

    .line {
      background: rgba(58, 106, 224, 1) !important;
    }

    .row4 {
      border-bottom: 1px dashed rgba(40, 89, 211, 1) !important;

      .font {
        background: rgba(30, 152, 246, 0.2) !important;
      }

      .yuan {
        background: rgba(58, 106, 224, 1) !important;
      }
    }
  }
}

::v-deep .van-field__control:disabled {
  color: #000 !important;
  -webkit-text-fill-color: #000;
}

//
.valve_active {
  color: #ffffff !important;
  background: rgba(58, 106, 224, 1) !important;
  border: 0.5px solid rgba(58, 106, 224, 1) !important;

  ::v-deep .van-field__control:disabled {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff;
  }
}

.progress {
  margin: 10px;

  .progress-text {
    width: 100%;
    text-align: center;
    margin-top: 5px;
    font-size: 12px;
  }
}
</style>
